import { library, config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCamera, faPencilAlt, faTrash, faRotateLeft, faCheck, faTimes, faGear } from "@fortawesome/free-solid-svg-icons";

config.autoAddCss = false;

library.add(faCamera, faPencilAlt, faTrash, faRotateLeft, faCheck, faTimes, faGear);

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("font-awesome-icon", FontAwesomeIcon);
});
